'use strict';

/**
 * Re-renders cart-level validation alerts (.cart-error) after AJAX cart updates.
 * Base SFRA validateBasket() appends on error but never clears when the basket becomes valid.
 */

function buildCartErrorHtml(message) {
	return (
		'<div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">' +
		'<span class="icon-info-circle" aria-hidden="true"></span>' +
		'<span class="valid-cart-error__message">' +
		message +
		'</span>' +
		'</div>'
	);
}

/**
 * @param {Object|null} payload - AJAX response (CartModel or { basket: CartModel }).
 */
function extractBasket(payload) {
	if (!payload) {
		return null;
	}
	if (payload.basket && payload.basket.valid) {
		return payload.basket;
	}
	if (payload.cartModel && payload.cartModel.valid) {
		return payload.cartModel;
	}
	if (payload.valid) {
		return payload;
	}
	return null;
}

/**
 * Mirrors the server-rendered blocked state of checkoutButtons.isml (Checkout CTA + express
 * container). Base SFRA only toggles the `disabled` class, so aria-disabled / tabindex / inert
 * would keep the CTAs blocked after the invalid line is removed.
 * @param {boolean} blocked - True when the basket is not valid for checkout.
 */
function syncCheckoutButtons(blocked) {
	$('.checkout-btn')
		.toggleClass('disabled', blocked)
		.attr({ 'aria-disabled': String(blocked), tabindex: blocked ? '-1' : '0' });
	$('#express-container')
		.toggleClass('express-container--disabled', blocked)
		.attr('aria-disabled', String(blocked))
		.prop('inert', blocked);
}

/**
 * @param {Object|null} basket - Cart model from the server.
 */
function updateCartErrorMessaging(basket) {
	if (!basket || !basket.valid) {
		return;
	}

	syncCheckoutButtons(!!basket.valid.error);
	$('.cart-error').empty();

	let itemCount = basket.items ? basket.items.length : 0;
	if (typeof basket.numItems === 'number' && itemCount === 0) {
		itemCount = basket.numItems;
	}

	if (basket.valid.error && basket.valid.message && itemCount > 0) {
		$('.cart-error').append(buildCartErrorHtml(basket.valid.message));
	}
}

function bindCartErrorMessaging() {
	$('body').on('cart:update', function (_e, data) {
		updateCartErrorMessaging(extractBasket(data));
	});

	$('body').on('promotion:success', function (_e, data) {
		updateCartErrorMessaging(extractBasket(data));
	});

	$('body').on('cart:shippingMethodSelected', function (_e, data) {
		if (data && !data.error) {
			updateCartErrorMessaging(extractBasket(data));
		}
	});

	$(document).on('ajaxComplete.cartErrorMessaging', function (_event, xhr, settings) {
		if (!settings || !settings.url || settings.url.indexOf('UpdateQuantity') === -1
			|| xhr.status < 400 || !xhr.responseJSON || !xhr.responseJSON.errorMessage) {
			return;
		}

		$('.cart-error').empty().append(buildCartErrorHtml(xhr.responseJSON.errorMessage));
	});
}

module.exports = function initCartErrorMessaging() {
	if ($('.cart-error').length) {
		bindCartErrorMessaging();
	}
};
